
export default {
    setExperiencia(state, data) {
        state.experiencia = data
    },
    setExperiencias(state, data) {
        state.experiencias = data
    },
}